import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private disableNavigation = new BehaviorSubject<boolean>(false);
  disableNavigation$ = this.disableNavigation.asObservable();

  constructor() {}

  isNullOrEmptyOrUndefined(value: string | undefined | number) {
    if (
      value == null ||
      value === '' ||
      value === 0 ||
      value === '0'
    ) {
      return true;
    }
    return false;
  }

  setNavigationDisabled(enabled: boolean) {
    this.disableNavigation.next(enabled);
  }
}
